document.addEventListener('mouseover.region', event => {
  setTimeout(() => {
    const floorNumber = event.detail.e.currentTarget.id.match(/[0-9]+/)?.[0] ?? "0";
    document.getElementById('floor-box').classList.add('active');
    document.getElementById('floor-box-number').textContent = floorNumber;
  }, 100);
});

document.addEventListener('mouseout.region', event => {
  document.getElementById('floor-box').classList.remove('active');
});

let isFloorPlanShown = false;
function showFloorPlan(floorId) {
  Array.from(document.getElementsByClassName('floor-plan'))
    .forEach(e => e.classList.remove('active'));
  document.getElementById(`floor-plan-${floorId}`).classList.add('active');

  document.querySelectorAll(`.floor-list-cell.active`)
    .forEach(e => e.classList.remove('active'));
  document.querySelector(`#floor-plans-list tr:nth-last-child(${floorId}) .floor-list-cell`)
    .classList.add('active');

  if (!isFloorPlanShown) {
    isFloorPlanShown = true;
    floorPlanWrap.style.height = floorPlanWrap.scrollHeight + 'px';
    setTimeout(() => floorPlanWrap.style.height = 'auto', 300);
  }

  const floorPlanBottomEdge = floorPlanWrap.getBoundingClientRect().top +
    floorPlanWrap.scrollHeight + window.scrollY;

  if (window.scrollY + window.innerHeight < floorPlanBottomEdge) {
    const top = floorPlanBottomEdge - window.innerHeight + 50;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}

const floorPlanWrap = document.getElementById('floor-plan');
document.addEventListener('click.region', event => {
  const floorId = event.detail.e.currentTarget.id.match(/[0-9]+/)?.[0] ?? "0";
  showFloorPlan(floorId);
});

const floorElements = document.querySelectorAll('.floor-list-cell');
floorElements.forEach(e => e.addEventListener('click', () => showFloorPlan(e.dataset.target)));

if (window.innerWidth <= 768 && floorElements.length > 0)
  showFloorPlan(1);
